export default {"src":"/_next/static/media/amb.9368a902.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};